/**
 * Requires a signed-in user, without requiring an organization.
 *
 * Used for /change-password, which is exactly the state where a user is
 * authenticated but not yet admitted to the ERP: they hold a temporary
 * password and a token that reaches the password-change endpoints only.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext.jsx';
import { LoadingState } from '../components/States.jsx';

export function RequireAuth({ children }) {
  const { t } = useTranslation('navigation');
  const { status, isAuthenticated, mustChangePassword } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <LoadingState label={t('shell.restoringSession')} />;
  if (!isAuthenticated) return <Navigate to="/login" replace state={{ from: location }} />;

  // Nothing left to change: send them on rather than showing a form whose
  // "current password" no longer exists.
  if (!mustChangePassword && location.pathname === '/change-password') {
    return <Navigate to="/" replace />;
  }

  return children;
}
